// Migrated from app/assets/javascripts/orange.js (inline code section)
// Orange layout: seatplan scaling, panels, Isotope, intlTelInput init

import 'jquery'

history.navigationMode = 'compatible';

var cwidth, cheight, cratio, sp_timeout = false, collapse_timeout = false;

function scaleSeatPlanTimed() {
  if (sp_timeout !== false)
    clearTimeout(sp_timeout);
  sp_timeout = setTimeout(function() {
    scaleSeatPlan();
  }, 100);
}
window.scaleSeatPlanTimed = scaleSeatPlanTimed;

function scaleSeatPlan() {
  if (typeof cwidth == "undefined") {
    cwidth = parseInt($(".kineticjs-content canvas:first").attr("width"));
    cheight = parseInt($(".kineticjs-content canvas:first").attr("height"));
    cratio = cwidth / cheight;
  }
  var width_to_set = $(".kineticjs-content").parents("div:first").width();
  if (width_to_set > cwidth) {
    width_to_set = cwidth;
  }
  $(".kineticjs-content canvas, .kineticjs-content").animate({
    "width": width_to_set + 'px',
    "height": Math.ceil(cratio * width_to_set) + 'px'
  }, 100);
  if (width_to_set < cwidth && $(".seatplan_large_link").length === 0) {
    var $modalLink = $("<a class=\"seatplan_large_link btn btn-default\" data-toggle=\"modal\" data-target=\"#largeSeatPlan\" href=\"javascript:;\">Klik voor een grote plattegrond</a>");

    $("#container").append($modalLink);
    $('#largeSeatPlan').on('shown.bs.modal', function(e) {
      $(".kineticjs-content").css({
        width: 'auto',
        height: 'auto'
      });
      $("#container .kineticjs-content").appendTo("#largeSeatPlan .modal-body");
      scaleSeatPlanTimed();
    });
    $('#largeSeatPlan').on('hidden.bs.modal', function(e) {
      $("#largeSeatPlan .modal-body .kineticjs-content").prependTo("#container");
      scaleSeatPlanTimed();
    });
  } else if (width_to_set < cwidth) {
    $(".seatplan_large_link").show();
  } else {
    $(".seatplan_large_link").hide();
  }
}
window.scaleSeatPlan = scaleSeatPlan;

function resizePanesTimed() {
  if (collapse_timeout !== false)
    clearTimeout(collapse_timeout);
  collapse_timeout = setTimeout(resizePanes, 200);
}

function resizePanes() {
  var dragging = false;
  $("body").on("touchmove", function(){
    dragging = true;
  }).on("touchstart", function(){
    dragging = false;
  });
  if ($(window).width() < 767) {
    $('#btn-pay').removeClass('btn-block');
    $('.main-panel-collapse.panel-collapse:not(:first)').collapse({
      toggle: false
    }).collapse('hide');

    $(".main-panel > .panel-heading").click(function() {
      if (!dragging){
        if(!$(this).closest('.panel').hasClass('active')){
          $('.panel').removeClass('active');
          $(this).closest('.panel').addClass('active');
          $('.main-panel-collapse.panel-collapse').collapse({
            toggle: false
          }).collapse('hide');
          $($(this).attr('href')).collapse({
            toggle: false
          }).collapse('show');
        }
      }
    });

    $(".btn-next-panel, .btn-prev-panel").click(function() {
      $('.main-panel-collapse.panel-collapse').collapse({
        toggle: false
      }).collapse('hide');
      $('.panel').removeClass('active');
      var next_id = $(this).data('next');
      $('#panel_'+next_id).collapse({
        toggle: false
      }).collapse('show').closest('.panel').addClass('active');
    });
  } else {
    $('#btn-pay').addClass('btn-block');
    $('.main-panel-collapse.panel-collapse').collapse({
      toggle: false
    }).collapse('show');
  }
}

// refresh check for back button
window.onload = window.onpageshow = function() {
  if ($("#refresh").val() == 'yes') {
    location.reload(true);
  } else {
    $('#refresh').val('yes');
  }
};

$(document).ready(function() {

  var windowWidth = $(window).width();
  $(window).resize(function(){
    if ($(window).width() != windowWidth) {
      windowWidth = $(window).width();
      scaleSeatPlanTimed();
      resizePanesTimed();
    }
  });
  resizePanes();
  scaleSeatPlanTimed();

  // ACCORDION
  $("body").on("click", "button.accordion-toggle", function() {
    if(!$(this).closest('.panel').hasClass('active')){
      $('.panel').removeClass('active');
      $(this).closest('.panel').addClass('active');
    }
    else {
      $(this).closest('.panel').removeClass('active');
    }
  });

  // ISOTOPE PANELS
  var $isotope_panel_container = $('#panel-container');
  var IsotopeIsActive = false;

  $.getScript('//cdn.jsdelivr.net/isotope/1.5.25/jquery.isotope.min.js', function() {
    isotope_panels();
  });

  function isotope_panels() {
    if ($(window).width() > 767 && $(window).width() < 992) {
      $isotope_panel_container.isotope({
        itemSelector: '.panel-wrapper',
        animationEngine: 'jquery',
        animationOptions: {
           duration: 0,
           easing: 'none',
           queue: false
         }
      });
      setTimeout(function(){
        isotope_panels();
      }, 100);
      IsotopeIsActive = true;
    } else if (IsotopeIsActive) {
      $isotope_panel_container.isotope('destroy');
      IsotopeIsActive = false;
    }
  }

  function resizeEnded() {
    isotope_panels();
  }

  var resizeTimer;
  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeEnded, 100);
  });


  $("#panelOneB").on("shown.bs.collapse", function(e) {
    scaleSeatPlanTimed();
  });

  setTimeout(function() {
    $('[data-toggle="tooltip"]').tooltip();
  }, 1500);

  $("#phone").intlTelInput({
    initialCountry: 'auto',
    geoIpLookup: function(callback) {
      $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
        var countryCode = (resp && resp.country) ? resp.country : "";
        callback(countryCode);
      });
    },
    utilsScript: "https://storage.googleapis.com/avayo-production/vendor/intl-tel-input/build/js/utils.js"
  });

});

// disable paste on email2
window.onload = function() {
  var myInput = document.getElementById('email2');
  if (myInput !== null) {
    myInput.onpaste = function(e) {
      e.preventDefault();
    };
  }
};
